import Alpine from "alpinejs";

Alpine.magic("instantsearch", () => async (params) => {
    const module = await import("instantsearch.js/dist/instantsearch.production.min.js");
    return module.default(params);
});